/** Bookkeeping is quoted forward from the start date, so say so up front. */
export const BacklogNotice = () => (
  <div
    data-testid="bookkeeping-backlog-notice"
    className="mt-5 rounded-xl border p-4"
    style={{
      borderColor: "var(--tt-warn-border)",
      backgroundColor: "var(--tt-warn-bg)",
    }}
  >
    <p className="text-sm font-bold" style={{ color: "var(--tt-warn-text)" }}>
      About backlogs — worth knowing up front
    </p>
    <p className="mt-1.5 text-[13px] leading-relaxed" style={{ color: "#4A3B10" }}>
      This quote is a monthly fee covering bookkeeping from your contract start date going
      forward. If you have a backlog of unprocessed records, we'll need to assess it separately
      and charge a once-off fee to bring your books up to date before the monthly service begins.
    </p>
  </div>
);
